import React from "react";

const Medications = ({ formData, handleChange, addMedication, removeMedication, addHospitalization, removeHospitalization, setActiveTab, selectedProgram, errors = {}, onNext }) => {
    return (
        <div id="medications" className="content">
            <div className="row g-3 justify-content-center">
                {/* --- Current Medications --- */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">List of Current Medications</small>
                    {formData.medications.map((med, index) => (
                        <div className="row g-2 align-items-center mb-2" key={index}>
                            <div className="col-md-7">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        className={`form-control ${index === 0 && errors.medications ? 'is-invalid' : ''}`}
                                        name={`medications.${index}.name`}
                                        value={med.name}
                                        onChange={handleChange}
                                        placeholder="Name"
                                    />
                                    <label>Name</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`medications.${index}.dosage`}
                                        value={med.dosage}
                                        onChange={handleChange}
                                        placeholder="Dosage"
                                    />
                                    <label>Dosage</label>
                                </div>
                            </div>
                            <div className="col-md-1 d-flex align-items-center">
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm w-100"
                                    onClick={() => removeMedication(index)}
                                >
                                    <i className="ri-close-line"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                    {errors.medications && (
                        <small className="text-danger d-block mt-2">{errors.medications}</small>
                    )}
                    <div className="col-md-12">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm mt-2 w-100"
                            onClick={addMedication}
                        >
                            <i className="ri-add-line"></i> Add Medication
                        </button>
                    </div>
                </div>
                {/* --- Prescribed By & Date --- */}
                <div className="col-md-7">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="text"
                            className={`form-control ${errors.prescribedBy ? 'is-invalid' : ''}`}
                            name="prescribedBy"
                            value={formData.prescribedBy}
                            onChange={handleChange}
                            placeholder="Prescribed by Dr."
                        />
                        <label>Prescribed by Dr.</label>
                        {errors.prescribedBy && (
                            <div className="invalid-feedback">{errors.prescribedBy}</div>
                        )}
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="form-floating form-floating-outline mb-3">
                        <input
                            type="date"
                            className={`form-control ${errors.prescriptionDate ? 'is-invalid' : ''}`}
                            name="prescriptionDate"
                            value={formData.prescriptionDate}
                            onChange={handleChange}
                        />
                        <label>Prescription Date</label>
                        {errors.prescriptionDate && (
                            <div className="invalid-feedback">{errors.prescriptionDate}</div>
                        )}
                    </div>
                </div>
                {/* --- Mental Health Services Previously Availed --- */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Mental Health Services Previously Availed
                    </small>
                    <div className="row g-2">
                        {[
                            "OPD with Psychiatrist",
                            "OPD with Therapist",
                            "In-patient Psychiatric Services",
                            "Psychiatric Rehab Services",
                            "Substance-Related Treatment",
                            "Occupational Therapy",
                            "Electroconvulsive Therapy (ECT)",
                            "Spiritual Treatment",
                            "Other",
                        ].map((option) => {
                            const inputId = `prevServices-${option}`;
                            return (
                                <div className="col-md-6" key={option}>
                                    <div className="form-check mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="prevServices"
                                            id={inputId}
                                            value={option}
                                            checked={formData.prevServices.includes(option)}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor={inputId}>
                                            {option}
                                        </label>

                                        {option === "Other" && formData.prevServices.includes("Other") && (
                                            <div className="form-floating form-floating-outline mt-2">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="otherService"
                                                    value={formData.otherService}
                                                    onChange={handleChange}
                                                    placeholder="Other"
                                                />
                                                <label>Other</label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* --- History of Previous Psychiatric Hospitalizations --- */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        History of Previous Psychiatric Hospitalizations
                    </small>
                    {formData.prevHospitalizations.map((hosp, index) => (
                        <div className="row g-2 mb-2" key={index}>
                            <div className="col-md-4">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`prevHospitalizations.${index}.hospital`}
                                        value={hosp.hospital}
                                        onChange={handleChange}
                                        placeholder="Hospital/Institute/Rehab"
                                    />
                                    <label>Hospital/Institute/Rehab</label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`prevHospitalizations.${index}.duration`}
                                        value={hosp.duration}
                                        onChange={handleChange}
                                        placeholder="Period of Stay"
                                    />
                                    <label>Period of Stay</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`prevHospitalizations.${index}.consultant`}
                                        value={hosp.consultant}
                                        onChange={handleChange}
                                        placeholder="Consultant Psychiatrist"
                                    />
                                    <label>Consultant Psychiatrist</label>
                                </div>
                            </div>
                            <div className="col-md-1 d-flex align-items-center">
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm w-100"
                                    onClick={() => removeHospitalization(index)}
                                >
                                    <i className="ri-close-line"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm mt-2 w-100"
                        onClick={addHospitalization}
                    >
                        <i className="ri-add-line"></i> Add Hospitalization
                    </button>
                </div>
                {/* --- Navigation Buttons --- */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm btn-prev w-100"
                            onClick={() => setActiveTab("client-info")}
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm btn-next ms-2 w-100"
                            onClick={onNext}
                        >
                            Next <i className="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Medications;